/* Auto-generated by tools/avatar-expressions/prepare_expression_assets.py. */
export const AVATAR_EXPRESSIONS = ["idle", "thinking", "play", "pass", "out", "win", "lose"] as const;
export type AvatarExpression = (typeof AVATAR_EXPRESSIONS)[number];

import avatar_01_idle from "../../../../assets/avatars/base/avatar-01.webp";
import avatar_01_thinking from "../../../../assets/avatars/expressions/avatar-01-thinking.webp";
import avatar_01_play from "../../../../assets/avatars/expressions/avatar-01-play.webp";
import avatar_01_pass from "../../../../assets/avatars/expressions/avatar-01-pass.webp";
import avatar_01_out from "../../../../assets/avatars/expressions/avatar-01-out.webp";
import avatar_01_win from "../../../../assets/avatars/expressions/avatar-01-win.webp";
import avatar_01_lose from "../../../../assets/avatars/expressions/avatar-01-lose.webp";
import avatar_02_idle from "../../../../assets/avatars/base/avatar-02.webp";
import avatar_02_thinking from "../../../../assets/avatars/expressions/avatar-02-thinking.webp";
import avatar_02_play from "../../../../assets/avatars/expressions/avatar-02-play.webp";
import avatar_02_pass from "../../../../assets/avatars/expressions/avatar-02-pass.webp";
import avatar_02_out from "../../../../assets/avatars/expressions/avatar-02-out.webp";
import avatar_02_win from "../../../../assets/avatars/expressions/avatar-02-win.webp";
import avatar_02_lose from "../../../../assets/avatars/expressions/avatar-02-lose.webp";
import avatar_03_idle from "../../../../assets/avatars/base/avatar-03.webp";
import avatar_03_thinking from "../../../../assets/avatars/expressions/avatar-03-thinking.webp";
import avatar_03_play from "../../../../assets/avatars/expressions/avatar-03-play.webp";
import avatar_03_pass from "../../../../assets/avatars/expressions/avatar-03-pass.webp";
import avatar_03_out from "../../../../assets/avatars/expressions/avatar-03-out.webp";
import avatar_03_win from "../../../../assets/avatars/expressions/avatar-03-win.webp";
import avatar_03_lose from "../../../../assets/avatars/expressions/avatar-03-lose.webp";
import avatar_04_idle from "../../../../assets/avatars/base/avatar-04.webp";
import avatar_04_thinking from "../../../../assets/avatars/expressions/avatar-04-thinking.webp";
import avatar_04_play from "../../../../assets/avatars/expressions/avatar-04-play.webp";
import avatar_04_pass from "../../../../assets/avatars/expressions/avatar-04-pass.webp";
import avatar_04_out from "../../../../assets/avatars/expressions/avatar-04-out.webp";
import avatar_04_win from "../../../../assets/avatars/expressions/avatar-04-win.webp";
import avatar_04_lose from "../../../../assets/avatars/expressions/avatar-04-lose.webp";
import avatar_05_idle from "../../../../assets/avatars/base/avatar-05.webp";
import avatar_05_thinking from "../../../../assets/avatars/expressions/avatar-05-thinking.webp";
import avatar_05_play from "../../../../assets/avatars/expressions/avatar-05-play.webp";
import avatar_05_pass from "../../../../assets/avatars/expressions/avatar-05-pass.webp";
import avatar_05_out from "../../../../assets/avatars/expressions/avatar-05-out.webp";
import avatar_05_win from "../../../../assets/avatars/expressions/avatar-05-win.webp";
import avatar_05_lose from "../../../../assets/avatars/expressions/avatar-05-lose.webp";
import avatar_06_idle from "../../../../assets/avatars/base/avatar-06.webp";
import avatar_06_thinking from "../../../../assets/avatars/expressions/avatar-06-thinking.webp";
import avatar_06_play from "../../../../assets/avatars/expressions/avatar-06-play.webp";
import avatar_06_pass from "../../../../assets/avatars/expressions/avatar-06-pass.webp";
import avatar_06_out from "../../../../assets/avatars/expressions/avatar-06-out.webp";
import avatar_06_win from "../../../../assets/avatars/expressions/avatar-06-win.webp";
import avatar_06_lose from "../../../../assets/avatars/expressions/avatar-06-lose.webp";
import avatar_07_idle from "../../../../assets/avatars/base/avatar-07.webp";
import avatar_07_thinking from "../../../../assets/avatars/expressions/avatar-07-thinking.webp";
import avatar_07_play from "../../../../assets/avatars/expressions/avatar-07-play.webp";
import avatar_07_pass from "../../../../assets/avatars/expressions/avatar-07-pass.webp";
import avatar_07_out from "../../../../assets/avatars/expressions/avatar-07-out.webp";
import avatar_07_win from "../../../../assets/avatars/expressions/avatar-07-win.webp";
import avatar_07_lose from "../../../../assets/avatars/expressions/avatar-07-lose.webp";
import avatar_08_idle from "../../../../assets/avatars/base/avatar-08.webp";
import avatar_08_thinking from "../../../../assets/avatars/expressions/avatar-08-thinking.webp";
import avatar_08_play from "../../../../assets/avatars/expressions/avatar-08-play.webp";
import avatar_08_pass from "../../../../assets/avatars/expressions/avatar-08-pass.webp";
import avatar_08_out from "../../../../assets/avatars/expressions/avatar-08-out.webp";
import avatar_08_win from "../../../../assets/avatars/expressions/avatar-08-win.webp";
import avatar_08_lose from "../../../../assets/avatars/expressions/avatar-08-lose.webp";
import avatar_09_idle from "../../../../assets/avatars/base/avatar-09.webp";
import avatar_09_thinking from "../../../../assets/avatars/expressions/avatar-09-thinking.webp";
import avatar_09_play from "../../../../assets/avatars/expressions/avatar-09-play.webp";
import avatar_09_pass from "../../../../assets/avatars/expressions/avatar-09-pass.webp";
import avatar_09_out from "../../../../assets/avatars/expressions/avatar-09-out.webp";
import avatar_09_win from "../../../../assets/avatars/expressions/avatar-09-win.webp";
import avatar_09_lose from "../../../../assets/avatars/expressions/avatar-09-lose.webp";
import avatar_10_idle from "../../../../assets/avatars/base/avatar-10.webp";
import avatar_10_thinking from "../../../../assets/avatars/expressions/avatar-10-thinking.webp";
import avatar_10_play from "../../../../assets/avatars/expressions/avatar-10-play.webp";
import avatar_10_pass from "../../../../assets/avatars/expressions/avatar-10-pass.webp";
import avatar_10_out from "../../../../assets/avatars/expressions/avatar-10-out.webp";
import avatar_10_win from "../../../../assets/avatars/expressions/avatar-10-win.webp";
import avatar_10_lose from "../../../../assets/avatars/expressions/avatar-10-lose.webp";
import avatar_11_idle from "../../../../assets/avatars/base/avatar-11.webp";
import avatar_11_thinking from "../../../../assets/avatars/expressions/avatar-11-thinking.webp";
import avatar_11_play from "../../../../assets/avatars/expressions/avatar-11-play.webp";
import avatar_11_pass from "../../../../assets/avatars/expressions/avatar-11-pass.webp";
import avatar_11_out from "../../../../assets/avatars/expressions/avatar-11-out.webp";
import avatar_11_win from "../../../../assets/avatars/expressions/avatar-11-win.webp";
import avatar_11_lose from "../../../../assets/avatars/expressions/avatar-11-lose.webp";
import avatar_12_idle from "../../../../assets/avatars/base/avatar-12.webp";
import avatar_12_thinking from "../../../../assets/avatars/expressions/avatar-12-thinking.webp";
import avatar_12_play from "../../../../assets/avatars/expressions/avatar-12-play.webp";
import avatar_12_pass from "../../../../assets/avatars/expressions/avatar-12-pass.webp";
import avatar_12_out from "../../../../assets/avatars/expressions/avatar-12-out.webp";
import avatar_12_win from "../../../../assets/avatars/expressions/avatar-12-win.webp";
import avatar_12_lose from "../../../../assets/avatars/expressions/avatar-12-lose.webp";
import avatar_13_idle from "../../../../assets/avatars/base/avatar-13.webp";
import avatar_13_thinking from "../../../../assets/avatars/expressions/avatar-13-thinking.webp";
import avatar_13_play from "../../../../assets/avatars/expressions/avatar-13-play.webp";
import avatar_13_pass from "../../../../assets/avatars/expressions/avatar-13-pass.webp";
import avatar_13_out from "../../../../assets/avatars/expressions/avatar-13-out.webp";
import avatar_13_win from "../../../../assets/avatars/expressions/avatar-13-win.webp";
import avatar_13_lose from "../../../../assets/avatars/expressions/avatar-13-lose.webp";
import avatar_14_idle from "../../../../assets/avatars/base/avatar-14.webp";
import avatar_14_thinking from "../../../../assets/avatars/expressions/avatar-14-thinking.webp";
import avatar_14_play from "../../../../assets/avatars/expressions/avatar-14-play.webp";
import avatar_14_pass from "../../../../assets/avatars/expressions/avatar-14-pass.webp";
import avatar_14_out from "../../../../assets/avatars/expressions/avatar-14-out.webp";
import avatar_14_win from "../../../../assets/avatars/expressions/avatar-14-win.webp";
import avatar_14_lose from "../../../../assets/avatars/expressions/avatar-14-lose.webp";
import avatar_15_idle from "../../../../assets/avatars/base/avatar-15.webp";
import avatar_15_thinking from "../../../../assets/avatars/expressions/avatar-15-thinking.webp";
import avatar_15_play from "../../../../assets/avatars/expressions/avatar-15-play.webp";
import avatar_15_pass from "../../../../assets/avatars/expressions/avatar-15-pass.webp";
import avatar_15_out from "../../../../assets/avatars/expressions/avatar-15-out.webp";
import avatar_15_win from "../../../../assets/avatars/expressions/avatar-15-win.webp";
import avatar_15_lose from "../../../../assets/avatars/expressions/avatar-15-lose.webp";
import avatar_16_idle from "../../../../assets/avatars/base/avatar-16.webp";
import avatar_16_thinking from "../../../../assets/avatars/expressions/avatar-16-thinking.webp";
import avatar_16_play from "../../../../assets/avatars/expressions/avatar-16-play.webp";
import avatar_16_pass from "../../../../assets/avatars/expressions/avatar-16-pass.webp";
import avatar_16_out from "../../../../assets/avatars/expressions/avatar-16-out.webp";
import avatar_16_win from "../../../../assets/avatars/expressions/avatar-16-win.webp";
import avatar_16_lose from "../../../../assets/avatars/expressions/avatar-16-lose.webp";
import avatar_17_idle from "../../../../assets/avatars/base/avatar-17.webp";
import avatar_17_thinking from "../../../../assets/avatars/expressions/avatar-17-thinking.webp";
import avatar_17_play from "../../../../assets/avatars/expressions/avatar-17-play.webp";
import avatar_17_pass from "../../../../assets/avatars/expressions/avatar-17-pass.webp";
import avatar_17_out from "../../../../assets/avatars/expressions/avatar-17-out.webp";
import avatar_17_win from "../../../../assets/avatars/expressions/avatar-17-win.webp";
import avatar_17_lose from "../../../../assets/avatars/expressions/avatar-17-lose.webp";
import avatar_18_idle from "../../../../assets/avatars/base/avatar-18.webp";
import avatar_18_thinking from "../../../../assets/avatars/expressions/avatar-18-thinking.webp";
import avatar_18_play from "../../../../assets/avatars/expressions/avatar-18-play.webp";
import avatar_18_pass from "../../../../assets/avatars/expressions/avatar-18-pass.webp";
import avatar_18_out from "../../../../assets/avatars/expressions/avatar-18-out.webp";
import avatar_18_win from "../../../../assets/avatars/expressions/avatar-18-win.webp";
import avatar_18_lose from "../../../../assets/avatars/expressions/avatar-18-lose.webp";
import avatar_19_idle from "../../../../assets/avatars/base/avatar-19.webp";
import avatar_19_thinking from "../../../../assets/avatars/expressions/avatar-19-thinking.webp";
import avatar_19_play from "../../../../assets/avatars/expressions/avatar-19-play.webp";
import avatar_19_pass from "../../../../assets/avatars/expressions/avatar-19-pass.webp";
import avatar_19_out from "../../../../assets/avatars/expressions/avatar-19-out.webp";
import avatar_19_win from "../../../../assets/avatars/expressions/avatar-19-win.webp";
import avatar_19_lose from "../../../../assets/avatars/expressions/avatar-19-lose.webp";
import avatar_20_idle from "../../../../assets/avatars/base/avatar-20.webp";
import avatar_20_thinking from "../../../../assets/avatars/expressions/avatar-20-thinking.webp";
import avatar_20_play from "../../../../assets/avatars/expressions/avatar-20-play.webp";
import avatar_20_pass from "../../../../assets/avatars/expressions/avatar-20-pass.webp";
import avatar_20_out from "../../../../assets/avatars/expressions/avatar-20-out.webp";
import avatar_20_win from "../../../../assets/avatars/expressions/avatar-20-win.webp";
import avatar_20_lose from "../../../../assets/avatars/expressions/avatar-20-lose.webp";
import avatar_21_idle from "../../../../assets/avatars/base/avatar-21.webp";
import avatar_21_thinking from "../../../../assets/avatars/expressions/avatar-21-thinking.webp";
import avatar_21_play from "../../../../assets/avatars/expressions/avatar-21-play.webp";
import avatar_21_pass from "../../../../assets/avatars/expressions/avatar-21-pass.webp";
import avatar_21_out from "../../../../assets/avatars/expressions/avatar-21-out.webp";
import avatar_21_win from "../../../../assets/avatars/expressions/avatar-21-win.webp";
import avatar_21_lose from "../../../../assets/avatars/expressions/avatar-21-lose.webp";
import avatar_22_idle from "../../../../assets/avatars/base/avatar-22.webp";
import avatar_22_thinking from "../../../../assets/avatars/expressions/avatar-22-thinking.webp";
import avatar_22_play from "../../../../assets/avatars/expressions/avatar-22-play.webp";
import avatar_22_pass from "../../../../assets/avatars/expressions/avatar-22-pass.webp";
import avatar_22_out from "../../../../assets/avatars/expressions/avatar-22-out.webp";
import avatar_22_win from "../../../../assets/avatars/expressions/avatar-22-win.webp";
import avatar_22_lose from "../../../../assets/avatars/expressions/avatar-22-lose.webp";
import avatar_23_idle from "../../../../assets/avatars/base/avatar-23.webp";
import avatar_23_thinking from "../../../../assets/avatars/expressions/avatar-23-thinking.webp";
import avatar_23_play from "../../../../assets/avatars/expressions/avatar-23-play.webp";
import avatar_23_pass from "../../../../assets/avatars/expressions/avatar-23-pass.webp";
import avatar_23_out from "../../../../assets/avatars/expressions/avatar-23-out.webp";
import avatar_23_win from "../../../../assets/avatars/expressions/avatar-23-win.webp";
import avatar_23_lose from "../../../../assets/avatars/expressions/avatar-23-lose.webp";
import avatar_24_idle from "../../../../assets/avatars/base/avatar-24.webp";
import avatar_24_thinking from "../../../../assets/avatars/expressions/avatar-24-thinking.webp";
import avatar_24_play from "../../../../assets/avatars/expressions/avatar-24-play.webp";
import avatar_24_pass from "../../../../assets/avatars/expressions/avatar-24-pass.webp";
import avatar_24_out from "../../../../assets/avatars/expressions/avatar-24-out.webp";
import avatar_24_win from "../../../../assets/avatars/expressions/avatar-24-win.webp";
import avatar_24_lose from "../../../../assets/avatars/expressions/avatar-24-lose.webp";

export const AVATAR_ART: Record<string, Record<AvatarExpression, string>> = {
  "avatar-01": {
    idle: avatar_01_idle,
    thinking: avatar_01_thinking,
    play: avatar_01_play,
    pass: avatar_01_pass,
    out: avatar_01_out,
    win: avatar_01_win,
    lose: avatar_01_lose,
  },
  "avatar-02": {
    idle: avatar_02_idle,
    thinking: avatar_02_thinking,
    play: avatar_02_play,
    pass: avatar_02_pass,
    out: avatar_02_out,
    win: avatar_02_win,
    lose: avatar_02_lose,
  },
  "avatar-03": {
    idle: avatar_03_idle,
    thinking: avatar_03_thinking,
    play: avatar_03_play,
    pass: avatar_03_pass,
    out: avatar_03_out,
    win: avatar_03_win,
    lose: avatar_03_lose,
  },
  "avatar-04": {
    idle: avatar_04_idle,
    thinking: avatar_04_thinking,
    play: avatar_04_play,
    pass: avatar_04_pass,
    out: avatar_04_out,
    win: avatar_04_win,
    lose: avatar_04_lose,
  },
  "avatar-05": {
    idle: avatar_05_idle,
    thinking: avatar_05_thinking,
    play: avatar_05_play,
    pass: avatar_05_pass,
    out: avatar_05_out,
    win: avatar_05_win,
    lose: avatar_05_lose,
  },
  "avatar-06": {
    idle: avatar_06_idle,
    thinking: avatar_06_thinking,
    play: avatar_06_play,
    pass: avatar_06_pass,
    out: avatar_06_out,
    win: avatar_06_win,
    lose: avatar_06_lose,
  },
  "avatar-07": {
    idle: avatar_07_idle,
    thinking: avatar_07_thinking,
    play: avatar_07_play,
    pass: avatar_07_pass,
    out: avatar_07_out,
    win: avatar_07_win,
    lose: avatar_07_lose,
  },
  "avatar-08": {
    idle: avatar_08_idle,
    thinking: avatar_08_thinking,
    play: avatar_08_play,
    pass: avatar_08_pass,
    out: avatar_08_out,
    win: avatar_08_win,
    lose: avatar_08_lose,
  },
  "avatar-09": {
    idle: avatar_09_idle,
    thinking: avatar_09_thinking,
    play: avatar_09_play,
    pass: avatar_09_pass,
    out: avatar_09_out,
    win: avatar_09_win,
    lose: avatar_09_lose,
  },
  "avatar-10": {
    idle: avatar_10_idle,
    thinking: avatar_10_thinking,
    play: avatar_10_play,
    pass: avatar_10_pass,
    out: avatar_10_out,
    win: avatar_10_win,
    lose: avatar_10_lose,
  },
  "avatar-11": {
    idle: avatar_11_idle,
    thinking: avatar_11_thinking,
    play: avatar_11_play,
    pass: avatar_11_pass,
    out: avatar_11_out,
    win: avatar_11_win,
    lose: avatar_11_lose,
  },
  "avatar-12": {
    idle: avatar_12_idle,
    thinking: avatar_12_thinking,
    play: avatar_12_play,
    pass: avatar_12_pass,
    out: avatar_12_out,
    win: avatar_12_win,
    lose: avatar_12_lose,
  },
  "avatar-13": {
    idle: avatar_13_idle,
    thinking: avatar_13_thinking,
    play: avatar_13_play,
    pass: avatar_13_pass,
    out: avatar_13_out,
    win: avatar_13_win,
    lose: avatar_13_lose,
  },
  "avatar-14": {
    idle: avatar_14_idle,
    thinking: avatar_14_thinking,
    play: avatar_14_play,
    pass: avatar_14_pass,
    out: avatar_14_out,
    win: avatar_14_win,
    lose: avatar_14_lose,
  },
  "avatar-15": {
    idle: avatar_15_idle,
    thinking: avatar_15_thinking,
    play: avatar_15_play,
    pass: avatar_15_pass,
    out: avatar_15_out,
    win: avatar_15_win,
    lose: avatar_15_lose,
  },
  "avatar-16": {
    idle: avatar_16_idle,
    thinking: avatar_16_thinking,
    play: avatar_16_play,
    pass: avatar_16_pass,
    out: avatar_16_out,
    win: avatar_16_win,
    lose: avatar_16_lose,
  },
  "avatar-17": {
    idle: avatar_17_idle,
    thinking: avatar_17_thinking,
    play: avatar_17_play,
    pass: avatar_17_pass,
    out: avatar_17_out,
    win: avatar_17_win,
    lose: avatar_17_lose,
  },
  "avatar-18": {
    idle: avatar_18_idle,
    thinking: avatar_18_thinking,
    play: avatar_18_play,
    pass: avatar_18_pass,
    out: avatar_18_out,
    win: avatar_18_win,
    lose: avatar_18_lose,
  },
  "avatar-19": {
    idle: avatar_19_idle,
    thinking: avatar_19_thinking,
    play: avatar_19_play,
    pass: avatar_19_pass,
    out: avatar_19_out,
    win: avatar_19_win,
    lose: avatar_19_lose,
  },
  "avatar-20": {
    idle: avatar_20_idle,
    thinking: avatar_20_thinking,
    play: avatar_20_play,
    pass: avatar_20_pass,
    out: avatar_20_out,
    win: avatar_20_win,
    lose: avatar_20_lose,
  },
  "avatar-21": {
    idle: avatar_21_idle,
    thinking: avatar_21_thinking,
    play: avatar_21_play,
    pass: avatar_21_pass,
    out: avatar_21_out,
    win: avatar_21_win,
    lose: avatar_21_lose,
  },
  "avatar-22": {
    idle: avatar_22_idle,
    thinking: avatar_22_thinking,
    play: avatar_22_play,
    pass: avatar_22_pass,
    out: avatar_22_out,
    win: avatar_22_win,
    lose: avatar_22_lose,
  },
  "avatar-23": {
    idle: avatar_23_idle,
    thinking: avatar_23_thinking,
    play: avatar_23_play,
    pass: avatar_23_pass,
    out: avatar_23_out,
    win: avatar_23_win,
    lose: avatar_23_lose,
  },
  "avatar-24": {
    idle: avatar_24_idle,
    thinking: avatar_24_thinking,
    play: avatar_24_play,
    pass: avatar_24_pass,
    out: avatar_24_out,
    win: avatar_24_win,
    lose: avatar_24_lose,
  },
};

export function avatarArt(avatarId: string, expression: AvatarExpression = "idle"): string {
  return AVATAR_ART[avatarId]?.[expression] ?? AVATAR_ART["avatar-01"]?.idle ?? "";
}
